/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../buttons";
import { useSpinnersContext } from "../../../contexts/spinnersContext";

/* Styles */
import styles from "./styles.js"


const Footer = props => {
  const { setShowModal, handleConfirmModal } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const spinner = useSpinnersContext();

  return (
    <ContainerFluid className="gx-0">
      <Row>
        <Col className={classes.cancelBtnCol}>
          <UCButton
            onClick={() => setShowModal(false)}
            type="default"
            className={classes.cancelBtn}
            disabled={spinner.deleteCompanyActionSpinner}
            text={<FormattedMessage id="declineModal.cancel"/>}
          />
        </Col>
        <Col className={classes.saveBtnCol}>
          <UCButton
            className={classes.saveBtn}
            onClick={handleConfirmModal}
            type="danger"
            text={<FormattedMessage id="declineModal.decline"/>}
            dataTestId="declineOfferButton"
            loadingStateStyling={ classes.customDisabled }
            spinner={{
              name: "declineOfferSpinner",
              size: 20,
            }}
          />
        </Col>
      </Row>
    </ContainerFluid>
  )
}

export default Footer;
